import { defineMessages } from 'react-intl'

const scope = `procurify.components.ExpenseItemTable`

export default defineMessages({
  tableLabel: {
    id: `${scope}.tableLabel`,
    defaultMessage: 'Expense item table',
  },
  emptyStateText: {
    id: `${scope}.emptyStateText`,
    defaultMessage: 'There are no expense items',
  },
  receiptLabel: {
    id: `${scope}.receiptLabel`,
    defaultMessage: 'Receipt',
  },
  vendorNameLabel: {
    id: `${scope}.vendorNameLabel`,
    defaultMessage: 'Vendor name',
  },
  accountCodeLabel: {
    id: `${scope}.accountCodeLabel`,
    defaultMessage: 'Account code',
  },
  expenseTypeLabel: {
    id: `${scope}.expenseTypeLabel`,
    defaultMessage: 'Expense type',
  },
  dateLabel: {
    id: `${scope}.dateLabel`,
    defaultMessage: 'Date',
  },
  paymentLabel: {
    id: `${scope}.paymentLabel`,
    defaultMessage: 'Payment method',
  },
  reimbursableLabel: {
    id: `${scope}.reimbursableLabel`,
    defaultMessage: 'Reimbursable',
  },
  taxLabel: {
    id: `${scope}.taxLabel`,
    defaultMessage: 'Tax',
  },
  taxAmountLabel: {
    id: `${scope}.taxAmountLabel`,
    defaultMessage: 'Tax amount',
  },
  taxProfileValue: {
    id: `${scope}.taxProfileValue`,
    defaultMessage: '{name} ({percentage})',
  },
  taxCustomAmountValue: {
    id: `${scope}.taxCustomAmountValue`,
    defaultMessage: 'Custom amount',
  },
  totalAmountLabel: {
    id: `${scope}.totalAmountLabel`,
    defaultMessage: 'Total amount',
  },
  positiveReimburseValue: {
    id: `${scope}.positiveReimburseValue`,
    defaultMessage: 'Yes',
  },
  negativeReimburseValue: {
    id: `${scope}.negativeReimburseValue`,
    defaultMessage: 'No',
  },
  paymentTypeCash: {
    id: `${scope}.paymentTypeCash`,
    defaultMessage: 'Cash',
  },
  paymentTypeCheque: {
    id: `${scope}.paymentTypeCheque`,
    defaultMessage: 'Cheque',
  },
  paymentTypeOther: {
    id: `${scope}.paymentTypeOther`,
    defaultMessage: 'Other',
  },
  editExpenseLineMenuLabel: {
    id: `${scope}.editExpenseLineMenuLabel`,
    defaultMessage: 'Edit expense item',
  },
  notesPrefix: {
    id: `${scope}.notesPrefix`,
    defaultMessage: 'Notes:',
  },
})
